module.exports = __webpack_public_path__ + "static/open-book-10cd3de99bf74674d8e61ad3db32b212.png";